"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var http_1 = require("@angular/common/http");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
require("rxjs/add/observable/combineLatest");
require("rxjs/add/observable/fromPromise");
require("rxjs/add/operator/bufferTime");
require("rxjs/add/operator/catch");
require("rxjs/add/operator/filter");
require("rxjs/add/operator/map");
require("rxjs/add/operator/mergeMap");
var Observable_1 = require("rxjs/Observable");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var access_1 = require("../../model/enum/access");
var custom_access_1 = require("../../model/enum/custom-access");
var HttpAuthorizationService = /** @class */ (function () {
    function HttpAuthorizationService(applicationPropertiesService, authenticationService, sessionDataProvider, http, ngZone) {
        var _this = this;
        this.applicationPropertiesService = applicationPropertiesService;
        this.authenticationService = authenticationService;
        this.sessionDataProvider = sessionDataProvider;
        this.http = http;
        this.ngZone = ngZone;
        this.permissionsToLoad = new ReplaySubject_1.ReplaySubject();
        this.permissionsLoaded = new Map();
        this.answers = new ReplaySubject_1.ReplaySubject();
        authenticationService.isLoggedOn().subscribe(function (loggedIn) {
            _this.permissionsLoaded.clear();
            _this.answers = new ReplaySubject_1.ReplaySubject();
        });
        this.scheduleGetPermissionValues();
    }
    HttpAuthorizationService_1 = HttpAuthorizationService;
    HttpAuthorizationService.prototype.getPermissionAccessValue = function (userId, permissionKey) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(userId);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(permissionKey);
        if (!this.permissionsLoaded.has(permissionKey)) {
            this.permissionsToLoad.next(permissionKey);
            var permissionValue = this.answers.filter(function (permissionResult) { return permissionResult.permissionKey === permissionKey; }).map(function (result) {
                return result.permissionValue;
            });
            this.permissionsLoaded.set(permissionKey, permissionValue);
            return permissionValue;
        }
        else {
            return this.permissionsLoaded.get(permissionKey);
        }
    };
    HttpAuthorizationService.prototype.getCategoryPermissionsValues = function (categoryPermissionRequestDataDto) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(categoryPermissionRequestDataDto);
        return this.getAuthorizationServiceUrl(HttpAuthorizationService_1.CATEGORY_PERMISSIONS_VALUES).flatMap(function (url) {
            return _this.http.post(url, categoryPermissionRequestDataDto)
                .map(function (result) { return HttpAuthorizationService_1.extractCategoryPermissionsValues(result); })
                .catch(HttpAuthorizationService_1.handleError);
        });
    };
    HttpAuthorizationService.prototype.getPermissionsAccessValue = function (userId, permissionsKeys) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(userId);
        var params = new http_1.HttpParams();
        params = params.set("userId", userId.toString());
        return this.getAuthorizationServiceUrl(HttpAuthorizationService_1.GRANTED).flatMap(function (url) {
            return _this.http.post(url, permissionsKeys, { params: params })
                .map(function (permissionResult) { return HttpAuthorizationService_1.extractPermissionsResult(permissionResult); })
                .catch(HttpAuthorizationService_1.handleError);
        });
    };
    HttpAuthorizationService.prototype.scheduleGetPermissionValues = function () {
        var _this = this;
        var currentUser$ = this.sessionDataProvider.getCurrentUserData();
        var permissionsToLoad$ = this.permissionsToLoad.bufferTime(100);
        this.ngZone.runOutsideAngular(function () { return Observable_1.Observable.combineLatest(currentUser$, permissionsToLoad$).subscribe(function (_a) {
            var userData = _a[0], permissionKeys = _a[1];
            if (permissionKeys.length > 0) {
                _this.getPermissionsAccessValue(userData.userId, permissionKeys).subscribe(function (permissionResults) {
                    var _loop_1 = function (result) {
                        _this.ngZone.run(function () { return _this.answers.next(result); });
                    };
                    for (var _i = 0, permissionResults_1 = permissionResults; _i < permissionResults_1.length; _i++) {
                        var result = permissionResults_1[_i];
                        _loop_1(result);
                    }
                });
            }
        }); });
    };
    HttpAuthorizationService.prototype.getAuthorizationServiceUrl = function (extension) {
        return Observable_1.Observable.fromPromise(this.applicationPropertiesService
            .getProperty(HttpAuthorizationService_1.AUTHORIZATION_SERVICE_URL_KEY)
            .then(function (serviceBase) { return serviceBase + HttpAuthorizationService_1.AUTHORIZATION_SERVICE_BASE_PATH + extension; }))
            .catch(HttpAuthorizationService_1.handleError);
    };
    HttpAuthorizationService.getAccess = function (value) {
        var access;
        switch (value) {
            case "CUSTOM":
                access = access_1.Access.CUSTOM;
                break;
            case "DENIED":
                access = access_1.Access.DENIED;
                break;
            case "FULL":
                access = access_1.Access.FULL;
                break;
            default:
                throw new Error("Wrong type can not match any Access type, available types are 'CUSTOM,DENIED,FULL'");
        }
        return access;
    };
    HttpAuthorizationService.getCustomAccess = function (value) {
        var customAccess;
        switch (value) {
            case "EXPRESSIONONLY":
                customAccess = custom_access_1.CustomAccess.EXPRESSIONONLY;
                break;
            case "FIELDS":
                customAccess = custom_access_1.CustomAccess.FIELDS;
                break;
            case "WORKFLOW":
                customAccess = custom_access_1.CustomAccess.WORKFLOW;
                break;
            case "WORKFLOWFIELD":
                customAccess = custom_access_1.CustomAccess.WORKFLOWFIELD;
                break;
            default:
                throw new Error("Wrong type can not match any CustomAccess type, available types are 'EXPRESSIONONLY,FIELDS,WORKFLOW,WORKFLOWFIELD'");
        }
        return customAccess;
    };
    HttpAuthorizationService.getCustomValue = function (value) {
        return {
            fields: value.fields ? HttpAuthorizationService_1.arrayToSet(value.fields) : null,
            expressions: value.expressions
        };
    };
    HttpAuthorizationService.arrayToSet = function (values) {
        var set = new Set();
        values.forEach(function (value) {
            set.add(value);
        });
        return set;
    };
    HttpAuthorizationService.extractPermissionsResult = function (permissionResult) {
        var permissionResultDto = [];
        for (var key in permissionResult.permissionResult) {
            permissionResultDto.push({
                permissionKey: key,
                permissionValue: {
                    expressions: permissionResult.permissionResult[key].expressions,
                    access: HttpAuthorizationService_1.getAccess(permissionResult.permissionResult[key].access)
                }
            });
        }
        return permissionResultDto;
    };
    HttpAuthorizationService.extractCategoryPermissionsValues = function (result) {
        var categoryPermissionValues = new Map();
        var _loop_2 = function (key) {
            var categoryPermissions = result[key];
            var categoryPermissionValueDtos = new Set();
            categoryPermissions.forEach(function (categoryPermission) {
                var access = HttpAuthorizationService_1.getAccess(categoryPermission.access);
                categoryPermissionValueDtos.add({
                    access: access,
                    customAccess: access === access_1.Access.CUSTOM ? HttpAuthorizationService_1.getCustomAccess(categoryPermission.customAccess) : null,
                    customValues: access === access_1.Access.CUSTOM ? HttpAuthorizationService_1.getCustomValue(categoryPermission.customValues) : null
                });
            });
            categoryPermissionValues.set(key, categoryPermissionValueDtos);
        };
        for (var key in result) {
            _loop_2(key);
        }
        return categoryPermissionValues;
    };
    HttpAuthorizationService.handleError = function (error) {
        console.error(error);
        return Observable_1.Observable.throw(error);
    };
    HttpAuthorizationService.AUTHORIZATION_SERVICE_URL_KEY = "um-authorization-service-url";
    HttpAuthorizationService.AUTHORIZATION_SERVICE_BASE_PATH = "/authorization";
    HttpAuthorizationService.CATEGORY_PERMISSIONS_VALUES = "/categoriespermissions";
    HttpAuthorizationService.GRANTED = "/granted";
    HttpAuthorizationService = HttpAuthorizationService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_authentication_client_js_1.AuthenticationService,
            idm_session_data_provider_api_js_1.SessionDataProvider,
            idm_authentication_client_js_1.HttpClientWrapper,
            core_1.NgZone])
    ], HttpAuthorizationService);
    return HttpAuthorizationService;
    var HttpAuthorizationService_1;
}());
exports.HttpAuthorizationService = HttpAuthorizationService;
//# sourceMappingURL=http-authorization.service.js.map